import React from 'react';
import { createUseStyles } from 'features/sharedModules/styles/components/styles.js';

const useStyles = createUseStyles(theme => ({
  circle: {
    fill: theme.checkmarkColor
  }
}));

const Checkmark = ({ className }) => {
  const classes = useStyles();

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle className={classes.circle} cx="20" cy="20" r="20" />
      <path d="M15 20L19 24L27 16" stroke="white" strokeWidth="2" />
    </svg>
  );
};

export default Checkmark;
